module.exports = __webpack_public_path__ + "static/media/Christie-Black-Logo.e75e9439.png";